import { Grid, Typography } from "@mui/material";
import { MS_IN_HOUR, RouteMetricSummary } from "../metric/RouteUtils";

type RouteSummaryProps = {
    metricsSummary: RouteMetricSummary,
};

const RouteSummary = ( { metricsSummary }: RouteSummaryProps ) =>
{
    const metrics = [
        { label: "miles", value: metricsSummary.distanceMi.toFixed( 1 ) },
        { label: "hrs driving", value: ( metricsSummary.drivingDurationMs / MS_IN_HOUR ).toFixed( 0 ) },
        { label: "overnights", value: metricsSummary.numberOfOvernights },
        { label: "hrs delayed", value: ( metricsSummary.totalWeatherDelayDurationMs / MS_IN_HOUR ).toFixed( 0 ) },
    ];

    return (
        <Grid container spacing = {2} justifyContent = "space-around" textAlign = "center">
            {metrics.map( ( metric ) => (
                <Grid item xs = {3} key = {metric.label}>
                    <Typography variant = "h6">{metric.value}</Typography>
                    <Typography fontSize = "10px">
                        {metric.label}
                    </Typography>
                </Grid>
            ) )}
        </Grid>
    );
};

export default RouteSummary;
